import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HERO } from "@/constants/testIds";
import {
  HeroBackgroundCarousel,
  HeroSlideDots,
} from "@/components/sections/hero/HeroCarousel";
import { HeroCategoriesList } from "@/components/sections/hero/HeroCategoriesList";
import { useHeroCarousel } from "@/components/sections/hero/useHeroCarousel";

const HERO_SLIDES = [
  {
    key: "hogar",
    label: "Hogar",
    url: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  },
  {
    key: "automovil",
    label: "Automóvil",
    url: "https://images.unsplash.com/photo-1553440569-bcc63803a83d?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  },
  {
    key: "empresa",
    label: "Empresa",
    url: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  },
  {
    key: "hospital",
    label: "Salud",
    url: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  },
];

const HeroCopy = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7 }}
  >
    <div className="eyebrow">Asesoría patrimonial · Desde 2007</div>
    <h1
      data-testid={HERO.question}
      className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] mt-6 text-razmek-dark"
    >
      <span className="text-razmek-gold">¿</span>
      Qué deseas
      <br />
      <span className="italic text-razmek-blue">proteger</span>
      <span className="text-razmek-gold">?</span>
    </h1>
    <p className="mt-8 max-w-xl font-sans text-lg leading-relaxed text-razmek-dark/70">
      Construimos estrategias de protección, ahorro e inversión a medida —
      pensadas como instrumentos de continuidad para tu patrimonio y para tu
      familia.
    </p>
    <div className="mt-10 flex flex-wrap items-center gap-4">
      <Link
        to="/precalificacion"
        data-testid={HERO.primaryCta}
        className="group inline-flex items-center gap-3 bg-razmek-blue hover:bg-razmek-dark text-white px-7 py-4 font-sans tracking-[0.16em] uppercase text-[11px] border-2 border-razmek-blue hover:border-razmek-gold transition-all"
      >
        Agendar una asesoría
        <ArrowUpRight
          size={16}
          className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </Link>
      <Link
        to="/historia"
        data-testid={HERO.secondaryCta}
        className="link-underline font-sans tracking-[0.16em] uppercase text-[11px] text-razmek-dark"
      >
        Conoce nuestra historia
      </Link>
    </div>
  </motion.div>
);

const Hero = () => {
  const [slideIdx, setSlideIdx] = useHeroCarousel(HERO_SLIDES, 5000);

  return (
    <section className="relative pt-32 lg:pt-40 pb-20 lg:pb-28 bg-white overflow-hidden">
      <HeroBackgroundCarousel slides={HERO_SLIDES} activeIdx={slideIdx} />
      <HeroSlideDots
        slides={HERO_SLIDES}
        activeIdx={slideIdx}
        onSelect={setSlideIdx}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <HeroCopy />
          </div>
          <div className="lg:col-span-5">
            <HeroCategoriesList />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
